import React from 'react'
import applicationStore from '../stores/applicationStore'
import HeaderConnect from './HeaderConnect'
import HeaderWallet from './HeaderWallet'

import { useAccount, useNetwork } from 'wagmi'
import KongLogo from './KongLogo'

export default function Header() {
  const { address, isConnected, isDisconnected } = useAccount()
  const { chain } = useNetwork()
  const disconnect = applicationStore((s) => s.walletDisconnect)
  const connect = applicationStore((s) => s.walletConnect)

  React.useEffect(() => {
    if (isConnected && address) {
      connect(address, chain?.id || 1)
    }

    if (isDisconnected) {
      disconnect()
    }
  }, [address, isConnected, isDisconnected])

  return (
    <header className="header">
      <KongLogo />
      {isConnected ? <HeaderWallet /> : <HeaderConnect />} {}
    </header>
  )
}
